import { TemplateCreatePayload, TemplateCopyPayload } from './Template.schema';

export const payloadToBody = (payload: Partial<TemplateCreatePayload | TemplateCopyPayload>): FormData =>
  Object.entries(payload).reduce((data, [key, value]) => {
    data.append(key, `${value}`);

    return data;
  }, new FormData());
